import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const NameField = forwardRef((props, ref) => {
  const { t } = useTranslation('userDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_name">
        {t('form.step2.name.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.name}
          id="form_name"
          name="name"
          ref={ref}
          {...other}
          placeholder={t('form.step2.name.placeholder')}
        />
        {errors.name && <Form.Error>{errors.name?.message}</Form.Error>}
      </Form.Control>
    </Form.Field>
  );
});

NameField.displayName = 'NameField';

NameField.propTypes = {
  errors: PropTypes.object,
};

export default NameField;
